import React from 'react';

const stats = [
  {
    label: '01 · Speed',
    value: '3 Weeks to 3 Days',
    desc: 'Compress multi-week deal workflows into days - with your deal team leading every gate.',
    active: true,
  },
  {
    label: '02 · Scale',
    value: '10× Deal Evaluation',
    desc: 'Decouples practice advisory margins and fund AUM from linear junior analyst hours.',
    active: false,
  },
  {
    label: '03 · Scope Unlock',
    value: 'Cross-Sector Depth',
    desc: 'Underwrite adjacent sectors outside historical expertise with instant domain depth.',
    active: false,
  },
];

export const StatsSection = () => {
  return (
    <section id="performance" className="py-10 sm:py-12 bg-[#090E1A] border-b border-white/10 text-white relative overflow-hidden">
      <div className="w-full max-w-[1680px] mx-auto px-4 sm:px-8 lg:px-12 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-white/10">
          {stats.map((stat, i) => (
            <div
              key={stat.label}
              className={`py-6 md:py-0 flex flex-col justify-between group ${
                i === 0 ? 'md:pr-10 lg:pr-14' : i === 1 ? 'md:px-10 lg:px-14' : 'md:pl-10 lg:pl-14'
              }`}
            >
              <div>
                <div className="flex items-center gap-2 mb-3">
                  <span className={`w-1.5 h-1.5 rounded-full ${stat.active ? 'bg-[#F58220]' : 'bg-slate-500 group-hover:bg-[#F58220]'} transition-colors`} />
                  <span className="text-[11px] font-mono font-semibold uppercase tracking-wider text-slate-400 group-hover:text-[#F58220] transition-colors">
                    {stat.label}
                  </span>
                </div>
                <div className="text-3xl sm:text-4xl font-extrabold text-white tracking-tight mb-2.5 font-sans">
                  {stat.value}
                </div>
                <p className="text-xs sm:text-[13px] text-slate-300 leading-relaxed font-sans max-w-sm">
                  {stat.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
